export default __webpack_public_path__ + "static/media/marker-yellow.52e90ecb.svg";